import { Avatar, Box, Toolbar, Typography } from '@mui/material'
import React from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import DashboardCard from '../../Dashboard/component/Card'
import ApexChart from '../../../../../components/Charts/Spline'
import { BarChart, HorizontalChart } from '../../../../../components'
import { formatDate, getRandomColor } from '../../../../../components/Table/TableCells/TableCell'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { highestInt } from '../../../../../shared/utils/constants'

export const Sales = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type

  const [selectedYear, setSelectedYear] = React.useState(new Date().getFullYear().toString())

  const { data: totalRevenue } = useGlobal({
    userUrl: `${urls.ANALYTICS}${customRole == 'Admin'  ? userSchoolId : ''}`,
  })

  const { data: feeData } = useGlobal({
    userUrl: `${urls.FEE_CHART}${customRole == 'Admin'  ? userSchoolId : ''}&year=${selectedYear}`,
  })
  const { data: newFee } = useGlobal({
    userUrl: `${urls.NEW_FEES}${customRole == 'Admin'  ? userSchoolId : ''}`,
  })

  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })

  const cardItems = [
    { title: 'Revenue', content: `₹${totalRevenue?.revenue || 0}` },
    { title: 'Fee Paid', content: `₹${feeData?.paid || 0}` },
    { title: 'Fee UnPaid', content: `₹${feeData?.unPaid || 0}` },
    { title: 'School', content: schoolList?.length },
  ]
  const filteredItems = cardItems.filter(
    (item) => !(customRole === 'Admin' && item.title === 'School'),
  )
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Sales Analytics'} subtitle={'Dashboard'} />
      <div className="dashboard-cards">
        {filteredItems.map((card, index) => (
          <DashboardCard key={index} title={card.title} content={card.content} stats={card.stats} />
        ))}
      </div>
      <div className="chart-area">
        <div style={{ width: '65%' }}>
          <div className="spline-ales-chart ">
            <ApexChart />
          </div>
          <Box mt={2} className="chart-container">
            <BarChart onClick={() => {}} />
          </Box>
        </div>
        <div style={{ width: '30%' }}>
          <div className="chart-container">
            <HorizontalChart
              sales
              feeData={feeData}
              selectedYear={selectedYear}
              setSelectedYear={setSelectedYear}
            />
          </div>
          <Box mt={2} className="chart-container">
            <ChartHead subheading={'New Paid'} heading={`New Fees`} />
            {newFee?.map((fee, index) => (
              <Box className="space-between sales-fee" key={index}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Avatar className="avatar-sales" sx={{ backgroundColor: getRandomColor() }}>
                    {fee?.student_name?.charAt(0).toUpperCase()}
                  </Avatar>
                  <div>
                    <Typography className="grey-text" fontSize={'14px'} fontWeight={700}>
                      {fee?.student_name}
                    </Typography>
                    <Typography className="grey-text" fontSize={'12px'}>
                      Paid fees on {formatDate(fee.createdAt)}
                    </Typography>
                  </div>
                </div>
                <Typography sx={{ color: '#039754', fontSize: '16px' }}>
                  ₹{fee.payment_total_amount}
                </Typography>
              </Box>
            ))}
            {/* <Typography className="view-all-txt" pb={6} mt={2}>
              View All activities <img src={viewAll} />
            </Typography> */}
          </Box>
        </div>
      </div>
    </div>
  )
}

export const ChartHead = ({ subheading, heading, children }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div>
        <Typography fontSize={'14px'} sx={{ color: '#667085' }}>
          {subheading}
        </Typography>
        <Typography fontSize={'32px'} fontWeight={900}>
          {heading}
        </Typography>
      </div>
      {children}
    </div>
  )
}
